module.exports = "/images/small-remove-gray-button.svg?ede0db338d5f6bfe902b461d0041aca1";